import { ConsentCategory } from '../ConsentService';
import * as featureFlagService from '../FeatureFlagService';

/**
 * @returns {void}
 */
export const initialize = () => {
  window.fwSettings = {
    widget_id: 7000000069,
    locale: window.top.TLGLOBALS.LANGUAGE_WITHOUT_LOCALIZATION,
  };

  if (typeof window.FreshworksWidget !== 'function') {
    const n = (...elements) => {
      n.q.push(elements);
    };

    n.q = [];

    window.FreshworksWidget = n;
  } else {
    // Already loaded

    return;
  }

  window.FreshworksWidget('hide', 'launcher');

  window.FreshworksWidget('identify', 'ticketForm', {
    name: window.top.TLGLOBALS.NAME,
    email: window.top.TLGLOBALS.EMAIL,
  });

  window.FreshworksWidget('hide', 'ticketForm', ['name', 'email']);

  const widgetLabels = {
    en: {
      banner: 'How can we help you?',
      contact_form: {
        title: 'Contact us',
        submit: 'Submit',
        confirmation: 'Thank you for your question.',
      },
    },
    nl: {
      banner: 'Hoe kunnen we je helpen?',
      contact_form: {
        title: 'Contacteer ons',
        submit: 'Verzenden',
        confirmation: 'Bedankt voor je vraag.',
      },
    },
    fr: {
      banner: 'Comment pouvons-nous vous aider ?',
      contact_form: {
        title: 'Contactez-nous',
        submit: 'Envoyer',
        confirmation: 'Merci pour votre question.',
      },
    },
    de: {
      banner: 'Wie können wir helfen?',
      contact_form: {
        title: 'Kontaktieren Sie uns',
        submit: 'Senden',
        confirmation: 'Danke für Ihre Frage',
      },
    },
    it: {
      banner: 'Come possiamo aiutarti?',
      contact_form: {
        title: 'Contattaci',
        submit: 'Invia',
        confirmation: 'Grazie per la tua domanda',
      },
    },
    es: {
      banner: '¿Cómo podemos ayudarte?',
      contact_form: {
        title: 'Contáctanos',
        submit: 'Enviar',
        confirmation: 'Gracias por tu pregunta.',
      },
    },
  };

  window.FreshworksWidget('setLabels', widgetLabels);

  window.FreshworksWidget('prefill', 'ticketForm', {
    custom_fields: {
      cf_how_does_this_impact_your_business: 'Low Impact [I have a question about Teamleader Focus]',
    },
  });

  const script = document.createElement('script');

  script.setAttribute('type', 'text/javascript');
  script.setAttribute('src', 'https://euc-widget.freshworks.com/widgets/7000000069.js');
  script.setAttribute('defer', 'defer');
  script.setAttribute('async', true);
  script.dataset.cookieconsent = ConsentCategory.Necessary;

  window.top.document.head.appendChild(script);
};

const prefillTicketForm = (subject = '', description = '') => {
  window.top.FreshworksWidget('prefill', 'ticketForm', {
    subject,
    description,
  });
};

/**
 * @returns {void}
 */
export const show = () => {
  if (isWidgetLoaded()) {
    window.top.FreshworksWidget('open');

    return;
  }

  openKnowledgeBaseInNewTab();
};

/**
 * @param {string} subject
 * @param {string} description
 * @returns {void}
 */
export const showContactUs = (subject, description) => {
  if (isWidgetLoaded()) {
    prefillTicketForm(subject, description);
    window.top.FreshworksWidget('open', 'ticketForm');

    return;
  }

  openKnowledgeBaseInNewTab();
};

const openKnowledgeBaseInNewTab = () => {
  window.open('https://support.focus.teamleader.eu', '_blank');
};

const isWidgetLoaded = () => {
  const isWidgetDisabled = featureFlagService.get('support.disable-freshdesk-help-widget');
  if (isWidgetDisabled) {
    return false;
  }

  return window.top.FreshworksWidget && !window.FreshworksWidget.q;
};

const FreshdeskHelpWidgetService = {
  show,
  showContactUs,
  initialize,
};

export default FreshdeskHelpWidgetService;
